import { FormData } from "src/pages/form-page/form-page";
import { makeCreditDecision} from "src/api/apiController";
import { formatDOB, getCurrentYearMonth, isLessThan12Months, monthNameToNumber } from "src/utils/date";
import { sanitizeAndTrimString } from "src/utils/form-helpers";
import { CreditDecisionInput } from "./make-credit-decision.types";

const GB_COUNTRY_CODE = "GB";

const query = `
    query FceQuoteSearchCreditDecision($input: FCEQuoteSearchCreditDecisionInput!) {
      fce {
        quote {
          fceQuoteSearchCreditDecision(input: $input) {
            decision
          }
        }
      }
    }
  `;

export const submitCreditApplication = async (correlationId: string, formData: FormData) => {
    const input = mapFormDataToInput(formData);
    const payload = {
        query: query.replaceAll("\n", ""),
        variables: { input },
        operationName: "FceQuoteSearchCreditDecision",
    };
    return makeCreditDecision(correlationId, payload);
};

const mapFormDataToInput = (formData: FormData): CreditDecisionInput => {
    const dobFormatted = formatDOB(formData.dobDay, formData.dobMonth, formData.dobYear);

    const payload: CreditDecisionInput = {
        forename: sanitizeAndTrimString(formData.firstName),
        surname: sanitizeAndTrimString(formData.lastName),
        emailAddress: sanitizeAndTrimString(formData.email),
        dateOfBirth: dobFormatted,
        income: Number.parseFloat(formData.income.replaceAll(",", "")),
        address: [
            {
                flatNumber: sanitizeAndTrimString(formData.currentAddress.flatNumber),
                buildingName: sanitizeAndTrimString(formData.currentAddress.houseName),
                houseNumber: sanitizeAndTrimString(formData.currentAddress.houseNumber),
                streetName: sanitizeAndTrimString(formData.currentAddress.street),
                city: sanitizeAndTrimString(formData.currentAddress.townCity),
                county: sanitizeAndTrimString(formData.currentAddress.county),
                postalCode: sanitizeAndTrimString(formData.currentAddress.postcode),
                countryCode: GB_COUNTRY_CODE,
                movedInDate: `${formData.currentAddress.year}-${monthNameToNumber(formData.currentAddress.month)}`,
                movedOutDate: getCurrentYearMonth(),  
                residentialStatus: "Current",
            },
        ],
    };

    if (isLessThan12Months(formData.currentAddress.month, formData.currentAddress.year)) {
        payload.address.push({
            flatNumber: sanitizeAndTrimString(formData.previousAddress?.flatNumber),
            buildingName: sanitizeAndTrimString(formData.previousAddress?.houseName),
            houseNumber: sanitizeAndTrimString(formData.previousAddress?.houseNumber),
            streetName: sanitizeAndTrimString(formData.previousAddress?.street),
            city: sanitizeAndTrimString(formData.previousAddress?.townCity),
            county: sanitizeAndTrimString(formData.previousAddress?.county),
            postalCode: sanitizeAndTrimString(formData.previousAddress?.postcode),
            countryCode: GB_COUNTRY_CODE,
            movedInDate: `${formData.previousAddress?.year}-${monthNameToNumber(formData.previousAddress?.month ?? "")}`,
            movedOutDate: `${formData.currentAddress.year}-${monthNameToNumber(formData.currentAddress.month)}`,
            residentialStatus: "Previous",
        });
    }

    return payload;
};
